import { atom, useAtomValue, useSetAtom } from 'jotai';

export interface GlobalQuery {
  platform?: General.PlatformUpperCase;
  region?: General.UpperCaseRegion;
}

export const globalQueryState = atom<GlobalQuery>({});

export const useGlobalQuery = () => {
  return useAtomValue(globalQueryState);
};

export const useSetGlobalQuery = () => {
  return useSetAtom(globalQueryState);
};
